import { createAsyncAction } from 'typesafe-actions'
import { IOrderSettings } from '../../../api'

export const FETCH_ORDER_SETTINGS = createAsyncAction(
  'order/FETCH_ORDER_SETTINGS',
  'order/FETCH_ORDER_SETTINGS_SUCCESS',
  'order/FETCH_ORDER_SETTINGS_FAILURE',
  'order/FETCH_ORDER_SETTINGS_CANCEL',
)<undefined, IOrderSettings, Error, undefined>()
